import k from '../k'
import addRobot from '../parts/addRobot'
import addUI from '../parts/addUI'
import addPart from '../parts/addPart'
import { platformSpeed } from '../state/globals'
import addVoid from '../parts/addVoid'

export default () => {
  k.setGravity(1000)
  k.add([k.sprite('background'), k.fixed()])

  const { partDisplay } = addUI(5)

  const robot = addRobot(true, partDisplay)
  const tooltipE = robot.add([k.sprite('e'), k.anchor('bot'), k.pos(0, -12)])
  tooltipE.hidden = true

  addPart(partDisplay, 820, -100)

  addVoid(250)

  k.add([
    k.sprite('small-grass'),
    k.pos(-20, 20),
    k.body({ isStatic: true }),
    k.area()
  ])

  k.add([
    k.sprite('small-grass'),
    k.pos(100, 10),
    k.body({ isStatic: true }),
    k.area()
  ])

  k.add([
    k.sprite('small-grass'),
    k.pos(220, 0),
    k.body({ isStatic: true }),
    k.area()
  ])

  k.add([
    k.sprite('small-grass'),
    k.pos(340, -10),
    k.body({ isStatic: true }),
    k.area()
  ])

  k.add([
    k.sprite('small-grass'),
    k.pos(460, -20),
    k.body({ isStatic: true }),
    k.area()
  ])

  k.add([
    k.sprite('small-grass'),
    k.pos(580, -30),
    k.body({ isStatic: true }),
    k.area()
  ])

  const platform = k.add([
    k.sprite('platform'),
    k.pos(700, -70),
    k.body({ isStatic: true }),
    k.area()
  ])

  let direction = platformSpeed
  platform.onUpdate(() => {
    if (platform.worldPos().y <= -80) direction = platformSpeed
    else if (platform.worldPos().y >= -30) direction = -platformSpeed

    platform.move(k.vec2(0, direction))
  })

  const grassFinal = k.add([
    k.sprite('small-grass'),
    k.pos(790, -80),
    k.body({ isStatic: true }),
    k.area()
  ])

  const door = grassFinal.add([
    k.sprite('door'),
    k.pos(70, 0),
    k.area(),
    k.anchor('bot'),
    k.z(-1),
    'door'
  ])

  let atDoor = false
  let doorOpen = false

  robot.onCollide('door', () => {
    atDoor = true
    tooltipE.hidden = false
  })
  robot.onCollideEnd('door', () => {
    atDoor = false
    tooltipE.hidden = true
  })
  robot.onKeyPress('e', () => {
    if (atDoor && !doorOpen) {
      doorOpen = true
      door.play('open')
    } else if (atDoor && doorOpen) {
      k.go('six')
    }
  })
}
